import { default as doubleRedemption } from "./double-redemption.json";
import { default as invalidReward } from "./invalid-reward.json";
import { default as notEnoughPoints } from "./not-enough-points.json";
import { default as resendReward } from "./resend-reward.json";
import { default as rewardsHistory } from "./rewards-history.json";

const data: { [key: string]: object } = {
  "double-redemption": doubleRedemption,
  "invalid-reward": invalidReward,
  "not-enough-points": notEnoughPoints,
  "resend-reward": resendReward,
  "rewards-history": rewardsHistory,
};

const rewards = {
  getError: (error: string) => data[error],
  get: () => data["rewards-history"],
  resend: () => data["resend-reward"],
};

export default rewards;
